import { useCallback, useState } from 'react';
import { IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { useSelectedSection, useSelectedWIR } from 'redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIRSignOffDTO } from 'types/wellGuardian';

import { useSectionUpdate } from './useSectionUpdate';

export const useResponsibleAndSignOffData = (intl: IntlShape) => {
  const [approvingUser, setApprovingUser] = useState<WIRSignOffDTO | null>(null);
  const [confirmApprovalModalOpen, setConfirmApprovalModalOpen] = useState<boolean>(false);
  const [approveLoading, setApproveLoading] = useState<boolean>(false);

  const wir = useSelectedWIR();
  const bothSections = useSelectedSection();
  const { processSaveResponse } = useSectionUpdate(bothSections, intl);

  const confirmApprovalOkMethod = useCallback(async () => {
    if (wir?.wirNumber && approvingUser) {
      setApproveLoading(true);
      const wirResponse = await wellGuardianApiClient.addSignOff(wir?.wirNumber, approvingUser);
      if (wirResponse?.wirNumber) {
        await processSaveResponse(wirResponse);
      } else {
        toast.error(
          intl.formatMessage({
            id: 'wellGuardian.wir.wirCreation.wirUpdateError',
          }),
        );
      }
      setApprovingUser(null);
      setConfirmApprovalModalOpen(false);
      setApproveLoading(false);
    }
  }, [approvingUser, wir, intl, processSaveResponse]);

  return {
    confirmApprovalOkMethod,
    setApprovingUser,
    confirmApprovalModalOpen,
    setConfirmApprovalModalOpen,
    approveLoading,
  };
};
